/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// Plugins
import { registerPlugins } from '@/plugins'

import * as Sentry from '@sentry/vue'
import * as p from '../package.json'

// Vue Datepickerに関するimport
// https://vue3datepicker.com/installation/
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { AwsRum, AwsRumConfig } from 'aws-rum-web'

const app = createApp(App)

if (import.meta.env.VITE_SEINTRY_DSN) {
  Sentry.init({
    app,
    environment: import.meta.env.VITE_STG ?? 'dev-local',
    release: p.name + '@' + p.version,
    dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: import.meta.env.VITE_SENTRY_SAMPLING_RATE ?? 0.5,
    tracePropagationTargets: ['graphql$'],
    replaysSessionSampleRate: import.meta.env.VITE_SENTRY_SESSION_SAMPLING_RATE ?? 0.1,
    replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_ERROR_SAMPLING_RATE ?? 1.0,
  })
}

try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    identityPoolId: import.meta.env.VITE_RUM_IDENTITY_POOL_ID,
    endpoint: import.meta.env.VITE_RUM_ENDPOINT,
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: true
  }

  const APPLICATION_ID: string = import.meta.env.VITE_RUM_APPLICATION_ID;
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'ap-northeast-3';

  new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config,
  )
} catch (e) {
  // ignore
}

registerPlugins(app)

app.component('VueDatePicker', VueDatePicker);
app.mount('#app')
